import {
  WorksheetBatchUpdateCommonDefaultParams,
  WorksheetBatchUpdateCommonQueryFields,
  WorksheetBatchUpdateCommonRequiredParams,
} from 'Components/WorksheetBatchUpdate/Core/SharedQueryFields';
import { WorksheetBatchUpdateDefinition } from '../..';
import {
  AsRelativeCompactionWorksheetFields,
  AsRelativeCompactionWorksheetSections,
} from './AsRelativeCompactionWorksheetFields';

const AsRelativeCompactionBatchUpdateDefinition: WorksheetBatchUpdateDefinition = {
  worksheetType: 'Relative Compaction',
  query: {
    defaultParams: WorksheetBatchUpdateCommonDefaultParams,
    requiredParams: WorksheetBatchUpdateCommonRequiredParams,
  },
  queryFields: WorksheetBatchUpdateCommonQueryFields,
  worksheetFields: AsRelativeCompactionWorksheetFields,
  worksheetFieldSections: AsRelativeCompactionWorksheetSections,
};

export default AsRelativeCompactionBatchUpdateDefinition;

export { AsRelativeCompactionBatchUpdateDefinition };
